import { useNavigate } from "@tanstack/react-router"
import { IconSquaresConnectedOutline18 as TeamsIcon } from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"

interface Props {
	onNavigate?: () => void
}

export const LinearTeamsDisabled = ({ onNavigate }: Props) => {
	const navigate = useNavigate()

	return (
		<div className="flex flex-col items-center gap-3 px-6 py-8 text-center">
			<TeamsIcon className="h-5 w-5 flex-none text-tertiary" />
			<div className="flex flex-col gap-1">
				<p className="text-sm font-medium text-primary">No teams enabled</p>
				<p className="text-sm text-secondary">
					Turn on a Linear team to pick from its work.
				</p>
			</div>
			<Button
				variant="default"
				size="sm"
				onClick={() => {
					onNavigate?.()
					void navigate({ to: "/settings/integrations/linear" })
				}}
			>
				Enable teams
			</Button>
		</div>
	)
}
